import '../../resources/js/buscador';

const Buscador = () =>{
    return (
        <div className="buscador hide-mobile" tabIndex="-1">
            <form action="https://www.cronica.com.ar/buscar.html" method="post">
                <label htmlFor="searchInput" aria-label="Buscar en Crónica"></label>
                <input className="search-input" type="text" name="q" id="searchInput" placeholder="Buscar en Crónica"/>
            </form>
            <span className="close-search"></span>
        </div>
    )
}
export default Buscador;